import { mountUnion, unmountUnion } from './union';

mountUnion();

if (window.Liferay) {
  window.Liferay.on('startNavigate', () => unmountUnion());
  window.Liferay.on('endNavigate', () => mountUnion());
}
